"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactRouterDom = require("react-router-dom");
var _SidenavStyled = _interopRequireDefault(require("./components/SidenavStyled"));
var _SidenavConsts = require("./SidenavConsts");
var _accessibility = require("../../constants/accessibility");
var _SidenavUtils = require("./SidenavUtils");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var defaultProps = {
  classes: {},
  hidden: false,
  minHoverTimeToOpen: 0,
  persistDrawerState: true,
  sidenavTabs: [],
  width: 240,
  withAppBarSpacing: false
};

/**
 * Side navigation bar provides access to modules and app functionality within an application.
 * Use side navigation bar when you have over five top-level destinations.
 * Side navigation bar can support at most 2 levels of navigation hierarchy.
 */
var Sidenav = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var classes = props.classes,
    dataMetrics = props.dataMetrics,
    drawerStartOpen = props.drawerStartOpen,
    hidden = props.hidden,
    minHoverTimeToOpen = props.minHoverTimeToOpen,
    persistDrawerState = props.persistDrawerState,
    sidenavTabs = props.sidenavTabs,
    width = props.width,
    withAppBarSpacing = props.withAppBarSpacing;
  var savedPinPreference = localStorage.getItem(_SidenavConsts.LOCAL_STORAGE_KEYS.SIDENAV_PINNED) === _SidenavConsts.LOCAL_STORAGE_KEYS.SIDENAV_PINNED_VALUE;
  var _useState = (0, _react.useState)(savedPinPreference),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    pin = _useState2[0],
    setPin = _useState2[1];
  var _useState3 = (0, _react.useState)(drawerStartOpen || savedPinPreference),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    open = _useState4[0],
    setOpen = _useState4[1];
  var _useState5 = (0, _react.useState)({
      tabIndex: 0,
      tabRoute: ''
    }),
    _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
    selectedTab = _useState6[0],
    setSelectedTab = _useState6[1];
  var _useState7 = (0, _react.useState)({
      tabIndex: null,
      tabRoute: ''
    }),
    _useState8 = (0, _slicedToArray2["default"])(_useState7, 2),
    focusedTab = _useState8[0],
    setFocusedTab = _useState8[1];
  var hoverTimer = null;
  var removeHoverTimer = function removeHoverTimer() {
    if (hoverTimer) {
      clearTimeout(hoverTimer);
    }
  };
  function mapRouteToTab(routeMatch) {
    if (routeMatch) {
      setSelectedTab(routeMatch);
    } else {
      setSelectedTab({
        tabIndex: -1,
        tabRoute: ''
      });
    }
  }
  var history = (0, _reactRouterDom.useHistory)();

  // on load: attempt to match current location path to sidenav route
  (0, _react.useEffect)(function () {
    var routeMatch = (0, _SidenavUtils.searchTabRoutes)(history.location.pathname, sidenavTabs);
    mapRouteToTab(routeMatch);
  }, [history, sidenavTabs]);

  // on pathname change: attempt to match location path to sidenav route
  (0, _react.useEffect)(function () {
    return history.listen(function (location) {
      var routeMatch = (0, _SidenavUtils.searchTabRoutes)(location.pathname, sidenavTabs);
      mapRouteToTab(routeMatch);
    });
  }, [history, sidenavTabs]);
  function handleDrawerOpen(force) {
    if (!open && sidenavTabs.length > 0) {
      if (minHoverTimeToOpen <= 0 || force) {
        setOpen(true);
      } else {
        hoverTimer = setTimeout(function () {
          setOpen(true);
          clearTimeout(hoverTimer);
        }, minHoverTimeToOpen);
      }
    }
  }
  var clearFocus = function clearFocus() {
    setFocusedTab({
      tabIndex: null,
      tabRoute: ''
    });
  };
  var handleOnFocus = function handleOnFocus() {
    var tabIndex = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var tabRoute = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    setFocusedTab({
      tabIndex: tabIndex,
      tabRoute: tabRoute
    });
  };
  function handleDrawerClose(clickedTab, forceClose) {
    if (forceClose) {
      setPin(false);
      (0, _SidenavUtils.removePinnedLocalStorage)();
    }
    if (!pin || forceClose) {
      setOpen(false);
      removeHoverTimer();
    }
    if (clickedTab !== null) setSelectedTab(clickedTab);
  }
  function onPinChange(pinned) {
    setPin(pinned);
    if (props.onPinChange) {
      props.onPinChange(pinned);
    }
  }
  var handleOnBlur = function handleOnBlur(fullSideNav) {
    return function (event) {
      if (fullSideNav) {
        // This is to work with cypress to be able to click to close
        removeHoverTimer();
      } else {
        event.stopPropagation();
        var isNavigationItemClick = event.relatedTarget && event.relatedTarget.tabIndex === -1;
        if (!isNavigationItemClick) {
          // Clear the focus when navigated to the pin
          clearFocus();
        }
      }
    };
  };
  var handleOnClick = function handleOnClick(tabIndex, tab) {
    return function (event) {
      var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        submenuRoute = _ref.submenuRoute,
        submenuCustomOnClick = _ref.submenuCustomOnClick,
        isKeyPress = _ref.isKeyPress;
      // Depending on the type of tab and navigation the events will be slightly different
      if (tab.divider) {
        event.preventDefault();
        return;
      }
      var correctRoute = submenuRoute || tab.route || event;
      var customOnClick = submenuCustomOnClick || tab.onClick;
      var isClickEvent = event.type === 'click';
      if (customOnClick) {
        event.preventDefault();
        customOnClick(event, correctRoute);
      } else {
        handleDrawerClose({
          tabIndex: tabIndex,
          tabRoute: event
        });
        setFocusedTab({
          tabIndex: isClickEvent ? null : tabIndex,
          tabRoute: correctRoute
        });
        /* 
           Check for key press event before manually pushing to history. 
           Calling history#push for a mouse click event results in pushing 
           to the history twice(triggering a console warning when using a hash router) 
           since it's already handled by the child Link component.
        */
        if (isKeyPress) {
          history.push(correctRoute);
        }
      }
      if (isKeyPress) {
        handleDrawerClose(null);
      }
    };
  };
  var handleArrowUpWorker = function handleArrowUpWorker(childRoute, tabIndex) {
    var newTabIndex;
    if (tabIndex !== undefined) {
      newTabIndex = tabIndex === 0 ? 0 : tabIndex - 1;
    } else if (focusedTab.tabIndex === null) {
      newTabIndex = selectedTab.tabIndex === 0 ? selectedTab.tabIndex : selectedTab.tabIndex - 1;
    } else {
      newTabIndex = focusedTab.tabIndex === 0 ? focusedTab.tabIndex : focusedTab.tabIndex - 1;
    }
    var theTab = sidenavTabs[newTabIndex];
    var divider = theTab.divider;
    if (divider && newTabIndex !== 0) {
      return handleArrowUpWorker(childRoute, newTabIndex);
    }
    var route = theTab.route;
    if (childRoute && sidenavTabs[focusedTab.tabIndex]) {
      newTabIndex = focusedTab.tabIndex;
      route = childRoute === _SidenavConsts.PARENT_NAVIGATION_ROUTE ? null : childRoute;
    }
    setFocusedTab({
      tabIndex: newTabIndex,
      tabRoute: route
    });
  };
  var handleArrowUp = function handleArrowUp(event, childRoute) {
    event.preventDefault();
    handleArrowUpWorker(childRoute);
  };
  var handleArrowDownWorker = function handleArrowDownWorker(childRoute, tabIndex) {
    var newTabIndex;
    var maxIndex = sidenavTabs.length - 1;
    if (tabIndex !== undefined) {
      newTabIndex = tabIndex === maxIndex ? tabIndex : tabIndex + 1;
    } else if (focusedTab.tabIndex === null) {
      newTabIndex = selectedTab.tabIndex === maxIndex ? maxIndex : selectedTab.tabIndex + 1;
    } else {
      newTabIndex = focusedTab.tabIndex === maxIndex ? maxIndex : focusedTab.tabIndex + 1;
    }
    var theTab = sidenavTabs[newTabIndex];
    var divider = theTab.divider;
    if (divider && newTabIndex !== maxIndex) {
      return handleArrowDownWorker(childRoute, newTabIndex);
    }
    var route = theTab.route;
    if (childRoute && sidenavTabs[focusedTab.tabIndex]) {
      newTabIndex = focusedTab.tabIndex;
      route = childRoute;
    }
    setFocusedTab({
      tabIndex: newTabIndex,
      tabRoute: route
    });
  };
  var handleArrowDown = function handleArrowDown(event, childRoute) {
    event.preventDefault();
    handleArrowDownWorker(childRoute);
  };
  var handleArrowLeft = function handleArrowLeft() {
    handleDrawerClose(null, true);
    var isParent = sidenavTabs[focusedTab.tabIndex] || sidenavTabs[focusedTab.tabIndex].subSections;
    if (isParent) {
      setFocusedTab({
        tabIndex: focusedTab.tabIndex,
        tabRoute: null
      });
    }
  };
  var handleEnter = function handleEnter(event, tab, tabIndex, childRoute) {
    if (!tab || childRoute === _SidenavConsts.PARENT_NAVIGATION_ROUTE) {
      return;
    }
    if (tab.subSections) {
      handleDrawerOpen(true);
    } else {
      handleOnClick(tabIndex, tab)(event);
    }
  };
  var handleOnKeyDown = function handleOnKeyDown(tabIndex, tab) {
    return function (event, childRoute) {
      switch (event.key) {
        case _accessibility.KEY_DOWN_MAP.ARROW_RIGHT:
          {
            handleDrawerOpen(true);
            break;
          }
        case _accessibility.KEY_DOWN_MAP.ARROW_LEFT:
          {
            handleArrowLeft();
            break;
          }
        case _accessibility.KEY_DOWN_MAP.ARROW_UP:
          {
            handleArrowUp(event, childRoute);
            break;
          }
        case _accessibility.KEY_DOWN_MAP.ARROW_DOWN:
          {
            handleArrowDown(event, childRoute);
            break;
          }
        case _accessibility.KEY_DOWN_MAP.ENTER:
          {
            handleEnter(event, tab, tabIndex, childRoute);
            break;
          }
        default:
          {
            break;
          }
      }
    };
  };
  return /*#__PURE__*/_react["default"].createElement(_SidenavStyled["default"], {
    classes: classes,
    dataMetrics: dataMetrics,
    focusedTab: focusedTab,
    handleOnBlur: handleOnBlur,
    handleOnFocus: handleOnFocus,
    handleOnKeyDown: handleOnKeyDown,
    handleDrawerOpen: handleDrawerOpen,
    handleDrawerClose: handleDrawerClose,
    hidden: hidden,
    onClick: handleOnClick,
    onPinChange: onPinChange,
    open: open,
    persistDrawerState: persistDrawerState,
    pin: pin,
    ref: ref,
    selectedTab: selectedTab,
    sidenavTabs: sidenavTabs,
    width: width,
    withAppBarSpacing: withAppBarSpacing
  });
});
Sidenav.defaultProps = defaultProps;
Sidenav.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * Override or extend the styles applied to the component.
   */
  classes: _propTypes["default"].object,
  /**
   * Override the data-metrics attributes applied to the component.
   */
  dataMetrics: _propTypes["default"].shape({
    pin: _propTypes["default"].string,
    root: _propTypes["default"].string
  }),
  /**
   * @ignore
   */
  drawerStartOpen: _propTypes["default"].bool,
  /**
   * Hides the drawer, but keeps the component in the DOM.
   */
  hidden: _propTypes["default"].bool,
  /**
   * The minimum hovering time (ms) required to open Sidenav.
   */
  minHoverTimeToOpen: _propTypes["default"].number,
  /**
   * Callback function for changes in Sidenav pinned status. Pinned status is passed as argument to callback.
   */
  onPinChange: _propTypes["default"].func,
  /**
   * Persist local storage state for expanded tabs.
   */
  persistDrawerState: _propTypes["default"].bool,
  /**
   * Array of drawer items.
   */
  sidenavTabs: _propTypes["default"].arrayOf(
  /**
   * sidenavTabs entry is either a tab definition or a divider.
   */
  _propTypes["default"].oneOfType([_propTypes["default"].shape({
    /**
     * Automationid is attached to inner anchor element and
     * can be utilized as selector.
     */
    automationid: _propTypes["default"].string,
    dataMetrics: _propTypes["default"].string,
    icon: _propTypes["default"].element.isRequired,
    route: _propTypes["default"].string,
    subSections: _propTypes["default"].arrayOf(_propTypes["default"].shape({
      childTabs: _propTypes["default"].arrayOf(_propTypes["default"].shape({
        automationid: _propTypes["default"].string,
        dataMetrics: _propTypes["default"].string,
        route: _propTypes["default"].string.isRequired,
        text: _propTypes["default"].string.isRequired
      })),
      header: _propTypes["default"].string
    })),
    text: _propTypes["default"].string.isRequired
  }), _propTypes["default"].shape({
    automationid: _propTypes["default"].string,
    dataMetrics: _propTypes["default"].string,
    divider: _propTypes["default"].bool
  })])),
  /**
   * Width of Sidenav when open.
   */
  width: _propTypes["default"].number,
  /**
   * Adds the appropriate top-margin to place the Sidenav below the AppBar.
   */
  withAppBarSpacing: _propTypes["default"].bool
} : {};
var _default = Sidenav;
exports["default"] = _default;